module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_FI-00-d1bc4b904bd8f0b1d5b579fac1911aab.svg";